export const getFirstContentfulPaintEntry = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  const entries = performance.getEntriesByType('paint');
  return entries.find((entry) => entry.name === 'first-contentful-paint');
};

export const getFirstContentfulPaintTime = () => {
  const entry = getFirstContentfulPaintEntry();
  return entry?.startTime ?? null;
};
